import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';

import CommentInput from './CommentInput';

const DefaultCommentInput = React.forwardRef<
  HTMLTextAreaElement,
  ComponentProps<typeof CommentInput> & {
    maxLength?: number;
    softLimit?: number;
    showCountThreshold?: number;
  }
>(({ focused, ...props }, ref) => {
  return <CommentInput ref={ref} {...props} />;
});

DefaultCommentInput.displayName = 'DefaultCommentInput';
DefaultCommentInput.propTypes = {
  /** Max characters allowed (activates character count) */
  maxLength: PropTypes.number,
};
export default DefaultCommentInput;
